<div class="all-title-box">
  <div class="container text-center">
    <h1>Contact<span class="m_1">Start a tracked inquiry</span></h1>
  </div>
</div>

<div id="support" class="section wb">
  <div class="container-fulid">
    <div class="section-title text-center">
      <h3>Tell us what you need</h3>
      <p class="lead">Submit a request and we will create a tracked inquiry with a status you can reference during follow-up.</p>
    </div>

    <div class="row">
      <div class="col-xl-7 col-md-12 col-sm-12">
        <div class="contact_form">
          <form id="contactform" [formGroup]="contactFormGroup" (ngSubmit)="submitContactDetails()" *ngIf="contactFormGroup">
            <fieldset class="row row-fluid">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-30">
                <input type="text" formControlName="first_name" id="first_name" class="form-control" placeholder="First Name">
                <app-validation [formGroupObj]="contactFormGroup" controlName="first_name" formName="CONTACT_FORM"></app-validation>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-30">
                <input type="text" formControlName="last_name" id="last_name" class="form-control" placeholder="Last Name">
                <app-validation [formGroupObj]="contactFormGroup" controlName="last_name" formName="CONTACT_FORM"></app-validation>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-30">
                <input type="email" formControlName="email" id="email" class="form-control" placeholder="Your Email">
                <app-validation [formGroupObj]="contactFormGroup" controlName="email" formName="CONTACT_FORM"></app-validation>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-30">
                <input type="text" formControlName="phone" id="phone" class="form-control" placeholder="Your Phone">
                <app-validation [formGroupObj]="contactFormGroup" controlName="phone" formName="CONTACT_FORM"></app-validation>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-30">
                <input type="text" formControlName="company" id="company" class="form-control" placeholder="Company (optional)">
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-30">
                <select formControlName="inquiry_type" id="inquiry_type" class="form-control">
                  <option value="general">General inquiry</option>
                  <option value="commercial">Commercial inquiry</option>
                  <option value="retail">Retail inquiry</option>
                  <option value="transportation">Transportation inquiry</option>
                  <option value="partnership">Partnership inquiry</option>
                  <option value="innovation">Innovation / holdings interest</option>
                  <option value="demo">Demo request</option>
                </select>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-30">
                <textarea class="form-control" formControlName="comments" id="comments" rows="6" placeholder="Give us more details"></textarea>
                <app-validation [formGroupObj]="contactFormGroup" controlName="comments" formName="CONTACT_FORM"></app-validation>
              </div>
              <div class="col-lg-12">
                <div class="alert alert-danger" *ngIf="submitError">{{ submitError }}</div>
                <div class="alert alert-success" *ngIf="submitSuccess">
                  Your inquiry was submitted successfully.
                  <strong>#{{ submitSuccess.id }}</strong>
                  was created with status <strong>{{ submitSuccess.status }}</strong>.
                </div>
              </div>
              <div class="text-center pd col-lg-12">
                <button type="submit" id="submit" class="btn btn-light btn-radius btn-brd grd1 btn-block" [disabled]="isSubmitting">
                  {{ isSubmitting ? 'Submitting...' : 'Submit Inquiry' }}
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
      <div class="col-xl-5 col-md-12 col-sm-12">
        <div class="contact-side-panel">
          <h4>What happens next</h4>
          <ol>
            <li>Your inquiry is created in the system.</li>
            <li>You receive a tracked inquiry id and initial status.</li>
            <li>The request can be routed and updated internally.</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</div>
